<template>
    <my-dialog :title="title" dialogType="form" :visible.sync="showDialog" :close-on-click-modal="false"
        @close="closeDialog" width="80%">
        <salesDetail ref="salesDetail" v-if="type == 2 || type == 6"></salesDetail>
        <rechargeDetail ref="rechargeDetail" v-else-if="type == 1 || type == 3"></rechargeDetail>

        <div class="item_info border_Danger">
            <el-descriptions class="margin-top" title="待发放提成" :column="3" border>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-user"></i>
                        员工
                    </template>
                    <span style="min-width: 100px;display: inline-block;">{{ commissionInfo.employeeName }}</span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-user"></i>
                        提成类型
                    </template>
                    {{ commissionInfo.typeStr }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-user"></i>
                        提成金额
                    </template>
                    <span style="color: red;min-width: 100px;display: inline-block;">￥{{ commissionInfo.money }}元</span>
                </el-descriptions-item>
            </el-descriptions>
        </div>

        <div slot="footer" class="dialog-footer">
            <el-button size="small" icon="el-icon-close" @click="closeDialog">关闭</el-button>
            <el-button v-if="this.$checkBtnPermission('/commission/main', 'grant') && !commissionInfo.isGrant" size="small" type="primary"
                class="el-icon-magic-stick" @click="handleGrantClick">
                发放
            </el-button>
        </div>
    </my-dialog>
</template>
<script>
import {
    BatchGrantCommission
} from "@/api/salaryApi.js";
import salesDetail from "@/views/product/sales/detail.vue";
import rechargeDetail from "@/views/vip/recharge/detail.vue";
export default {
    props: [],
    data() {
        return {
            showDialog: false,
            type: 0,
            title: "提成关联业务详情",
            keyId: "",
            commissionInfo: {}
        };
    },
    components: {
        salesDetail,
        rechargeDetail,
    },
    created() { },
    methods: {
        // 显示
        getGrantDialog(row) {
            this.commissionInfo = row;
            this.keyId = row.keyId;
            this.showDialog = true;
            this.type = row.type;
            this.$nextTick(() => {
                if (this.type == 2 || this.type == 6) {
                    this.title = "提成关联【销售订单】详情";
                    this.$refs.salesDetail.getCommissionDetail(row);
                } else if (this.type == 1 || this.type == 3) {
                    this.title = "提成关联【充值订单】详情";
                    this.$refs.rechargeDetail.getCommissionDetail(row);
                }
            })
        },
        // 关闭
        closeDialog() {
            this.keyId = "";
            this.type = 0;
            this.showDialog = false;
        },
        handleGrantClick() {
            if (this.keyId == "") {
                this.$message.error("请选择提成信息！");
                return;
            }
            this.$confirm('确认发放选中的提成记录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                var params = {
                    keyIds: [this.keyId]
                }
                BatchGrantCommission(params).then((res) => {
                    if (res.code == 1) {
                        this.$message({
                            type: 'success',
                            message: '发放成功',
                        });
                        this.closeDialog();
                        this.$parent.getListData();
                    } else {
                        this.$message.error(res.msg);
                    }
                }).catch((err) => {
                    this.$message.error("发放失败!");
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消发放',
                });
            });
        }
    },
};
</script>
<style scoped lang="scss">
.main_bg {
    padding: 10px;
    margin-top: -15px;
}

.item_info {
    border-left: 5px solid #55aaff;
    padding: 5px 10px;
    border-radius: 5px;
    margin-bottom: 15px;
    border-bottom: 2px solid #e9e7e7;
}

.border_Warningcolor {
    border-left: 5px solid #ff9900;
}

.border_Green {
    border-left: 5px solid #00cc66;
}

.border_Danger {
    border-left: 5px solid #ff0000;
}

.item_title {
    display: flex;
    width: 100%;
    font-weight: 700;
    font-size: 1rem;
    margin-bottom: 10px;
    justify-content: space-between;

    .title {
        display: inline-block;
        unicode-bidi: isolate;
    }

    .btnDiv {
        display: block;
        unicode-bidi: isolate;
        word-break: break-all;
    }

    .btnDivItem {
        display: inline-block;
    }

    .text-red {
        display: block;
        background-color: #ff0000;
    }
}
</style>